import { SVGAttributes } from 'react'

export const EventSpace = (props: SVGAttributes<SVGElement>) => (
  <svg {...props} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.1393 42.8717L13.0691 44.302M16.9988 45.7323L13.0691 44.302M13.0691 44.302L16.6449 34.4776M16.6449 34.4776C15.3713 34.0141 11.316 31.7963 13.4511 27.6286M16.6449 34.4776C17.9184 34.9411 22.232 35.7695 23.4939 31.2839L24.6267 26.1332M13.4511 27.6286L18.1184 18.2014L25.7596 20.9826L24.6267 26.1332M13.4511 27.6286L24.6267 26.1332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.5682 44.8717L42.6385 46.302M38.7087 47.7323L42.6385 46.302M42.6385 46.302L39.0626 36.4776M39.0626 36.4776C40.3362 36.0141 44.3915 33.7963 42.2564 29.6286M39.0626 36.4776C37.7891 36.9411 33.4755 37.7695 32.2137 33.2839L31.0808 28.1332M42.2564 29.6286L37.5891 20.2014L29.9479 22.9826L31.0808 28.1332M42.2564 29.6286L31.0808 28.1332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="27.4209"
      y1="14.2786"
      x2="27.4209"
      y2="8.75008"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="0.75"
      y1="-0.75"
      x2="6.27769"
      y2="-0.75"
      transform="matrix(0.709897 -0.704305 0.709897 0.704305 32.5952 15.2004)"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="0.75"
      y1="-0.75"
      x2="6.27769"
      y2="-0.75"
      transform="matrix(-0.709897 -0.704305 0.709897 -0.704305 23.7468 14.1533)"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
